// TODO: move component into src/spa/components/
import React from 'react'
import PropTypes from 'prop-types'
import DOMPurify from 'dompurify'
import { getBackgroundColor } from '../statistics/statsUtils.js'
import { camelCase } from 'lodash'
import { textAlignments } from '../statistics/statsConstants.js'
import { joinClassList } from '../utilities/utilities.js'

const Introduction = ({
  title,
  content,
  reverseTheme,
  introAlignment,
  underlineTitle,
  removeAllCaps,
}) => {
  const textColor = reverseTheme && 'u-textColorWhite'
  const alignment = textAlignments[introAlignment] || ''
  const decorateTitle = underlineTitle && 'u-textDecoUnderline'
  const titleClasses = joinClassList([
    removeAllCaps ? 'u-textNoTransform' : 'u-textUppercase',
    'u-marginBottom4gu',
    textColor,
    decorateTitle,
  ])
  return (
    <div className={joinClassList(['Introduction', alignment])}>
      {title && <h2 className={titleClasses}>{title}</h2>}
      {content && (
        <div
          className={joinClassList(['u-marginVert4gu', textColor])}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        ></div>
      )}
    </div>
  )
}

Introduction.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  underlineTitle: PropTypes.bool,
  introAlignment: PropTypes.string,
  removeAllCaps: PropTypes.bool,
  reverseTheme: PropTypes.bool,
}

export const getIntroProps = (doc, parameters) => {
  const docData = doc.getData()
  return {
    title: docData.title?.trim(),
    content: docData.html?.value?.trim(),
    backgroundColor: getBackgroundColor(parameters.backgroundColor),
    introAlignment: camelCase(parameters.introAlignment),
    underlineTitle: parameters.titleStyle,
    reverseTheme: parameters.theme === 'reversed',
    removeAllCaps: parameters?.transformUppercase,
  }
}

export default Introduction
